import React from "react"
import { Link } from "react-router-dom"
import { ArrowRight } from "lucide-react"

const posts = [
  {
    id: 1,
    category: "Design Theory",
    title: "The Geometry of Silence: How Negative Space Defines Architecture",
    excerpt:
      "Understanding how the voids between structures carry as much weight as the materials themselves — a study in restraint.",
    date: "May 28, 2025",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1486325212027-8081e485255e?w=600&q=80&fit=crop",
  },
  {
    id: 2,
    category: "Materials",
    title: "Brutalism Reimagined: Concrete's New Softness",
    excerpt:
      "How contemporary practices are reclaiming raw concrete — pairing it with warmth, texture, and unexpected lightness.",
    date: "May 14, 2025",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1518005020951-eccb494ad742?w=600&q=80&fit=crop",
  },
  {
    id: 3,
    category: "Interior",
    title: "Lighting as Architecture: Sculpting Space with Lumens",
    excerpt:
      "A deep dive into how thoughtful lighting design transforms the perception of volume, material, and emotional atmosphere.",
    date: "Apr 30, 2025",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=600&q=80&fit=crop",
  },
]

export default function JournalSection() {
  return (
    <section className="py-24 lg:py-32 bg-stone-900">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <span className="inline-flex items-center gap-2 font-['Space_Grotesk'] text-[10px] tracking-[0.3em] text-amber-400 uppercase mb-4">
              <span className="w-6 h-px bg-amber-400" />
              Journal
            </span>
            <h2 className="font-['Cormorant_Garamond'] text-4xl lg:text-6xl font-light text-stone-100 leading-tight">
              Ideas &<br />
              <span className="italic text-stone-400">Perspectives</span>
            </h2>
          </div>
          <Link
            to="/journal"
            className="inline-flex items-center gap-2 font-['Space_Grotesk'] text-[11px] tracking-[0.2em] text-stone-400 hover:text-amber-400 transition-colors group self-start lg:self-auto"
          >
            ALL ARTICLES
            <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>

        {/* Posts Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {posts.map((post) => (
            <article key={post.id} className="group cursor-pointer">
              <div className="overflow-hidden mb-5 h-52">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div>
                <div className="flex items-center gap-3 mb-3">
                  <span className="font-['Space_Grotesk'] text-[9px] tracking-[0.25em] text-amber-400 uppercase">
                    {post.category}
                  </span>
                  <span className="w-1 h-1 rounded-full bg-stone-600" />
                  <span className="font-['Inter'] text-xs text-stone-500">{post.date}</span>
                </div>
                <h3 className="font-['Cormorant_Garamond'] text-2xl font-light text-stone-100 leading-tight mb-3 group-hover:text-amber-200 transition-colors">
                  {post.title}
                </h3>
                <p className="font-['Inter'] text-sm text-stone-400 leading-relaxed mb-4">{post.excerpt}</p>
                <span className="inline-flex items-center gap-2 font-['Space_Grotesk'] text-[10px] tracking-[0.2em] text-stone-500 group-hover:text-amber-400 transition-colors">
                  READ MORE <ArrowRight size={12} />
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
